import { createProjectKeyText } from '../../../../common/ui/illustration/issue-key-text';

export const truncateText = (text: string, length: number) =>
	text.length > length ? `${text.substring(0, length - 1)}...` : text;

export const transformProjectKeyText = (projectKey: string, issueNumber: number) =>
	truncateText(createProjectKeyText(projectKey, issueNumber), 6);
